'use strict';
module.exports = function cleanNonPrintable (string) {
	if (typeof string !== 'string') {
		return '';
	}

	const noHiddenUnicode =  string.replace(/[\u0000-\u0008\u000B-\u000C\u000E-\u001F\u007F\u0080-\u009F]+/gu, ''); //eslint-disable-line no-control-regex

	return noHiddenUnicode.replace(/[\u00a0]+/gu, ' ');
};
